import PurseHand from '../../src/legacy/PurseHand.tsx';
export default PurseHand;
